<!-- extract this to an other component -->
<div ngDraggable class="fixed top-12 right-4 md:top-4 z-20">
  <div
    [ngClass]="{
      timer: true,
      'timer-danger': showTimerDanger
    }"
  >
    <p class="mb-2">
      Time remaining to reserve the selected tickets:
      <span class="time">
        {{ orderTimeRemainingFormatted }}
      </span>
    </p>

    <mat-progress-bar
      [value]="orderTimePercentageRemaining * 100"
    ></mat-progress-bar>
  </div>
</div>

<div class="order-summary-section">
  <tix-card class="order-sauumary-card">
    <tix-card-content>
      <tix-card-title>
        <h3>Order Summary</h3>
      </tix-card-title>
      <div class="order-summary-table">
        <div class="order-summary-head">
          <div class="order-summary-head-row">
            <div class="order-head-item"></div>
            <div class="order-head-item">
              <div class="order-head-inner-row">
                <div class="order-head-inner-item">
                  <h4>NAME</h4>
                </div>
                <div class="order-head-inner-item">
                  <h4>TICKET TYPE</h4>
                </div>
                <!-- <div class="order-head-inner-item">
                  <h4>SERVICE FEE</h4>
                </div> -->
                <!-- <div class="order-head-inner-item"><h4>REMAINING</h4></div> -->
                <div class="order-head-inner-item">
                  <h4>QUANTITY</h4>
                </div>
                <div class="order-head-inner-item"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="order-summary-body">
          <div *ngIf="event$ && event$ | async as event">
            <ng-container *ngIf="orderInfo; else noItems">
              <tix-order-items
                [tickets]="orderInfo.tickets"
                [event]="event"
                (onTicketsChange)="onChange($event)"
              ></tix-order-items>

              <!-- start: addons -->
              <tix-products-summary (selectionChanged)="updateProducts($event)">
                <!-- Products, products-summary, products summary, summary-products, summary products -->
              </tix-products-summary>
              <!-- end: addons -->
            </ng-container>
            <ng-template #noItems>
              <div class="event-card-nodata">NO DATA AVAILABLE</div>
            </ng-template>
          </div>

          <!-- Amounts -->

          <div class="order-summary-footer">
            <div class="order-summary-foot-row">
              <div class="order-summary-foot-item">
                <ul class="order-summary-total-list">
                  <li>
                    <!-- DONT DELETE THE `-ml-0.5` UTILITY -->
                    <label><div class="-ml-0.5">TICKET TOTAL</div></label>
                    <h4>{{ ticketsSubtotal | currency }}</h4>
                  </li>
                  <li>
                    <!-- DONT DELETE THE `-ml-0.5` UTILITY -->
                    <label><div class="-ml-0.5">ADD-ON TOTAL</div></label>
                    <h4>
                      {{ addonsSubtotal | currency }}
                    </h4>
                  </li>
                  <li class="border-t-2 border-dashed">
                    <label class="font-semibold">SUBTOTAL</label>
                    <h4 class="font-bold">
                      {{ addonsSubtotal + ticketsSubtotal | currency }}
                    </h4>
                  </li>
                  <li>
                    <label>DISCOUNT</label>
                    <h4>{{ discountAmount | currency }}</h4>
                  </li>
                  <li>
                    <label>DONATION</label>
                    <h4>
                      {{ donationAmount | currency }}
                    </h4>
                  </li>
                  <li>
                    <label>FEE TOTAL</label>
                    <h4>{{ feesTotal | currency }}</h4>
                  </li>
                  <li>
                    <label>TAX</label>
                    <h4>{{ addonsTax | currency }}</h4>
                  </li>
                  <li class="border-t-2 border-dashed">
                    <label class="font-semibold">TOTAL</label>
                    <h4 class="font-bold">
                      {{ amountToPay | currency }}
                    </h4>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tix-card-content>

    <ng-container *ngIf="eventLoaded">
      <div
        *ngIf="!canBuy"
        class="w-full px-5 py-4 bg-red-500 rounded-md bg-opacity-20"
      >
        {{ discountError || 'must select at least one ticket to buy' }}
      </div>
    </ng-container>
  </tix-card>

  <tix-card class="payment-detail-card">
    <tix-card-content>
      <tix-card-title>
        <h3>
          {{ !needCreditCard ? 'Reservation Details' : 'Add Payment Details' }}
        </h3>
      </tix-card-title>
      <div class="tix-payment-wrapper">
        <form action="" [formGroup]="paymentForm">
          <div class="tix-payment-field-wrap">
            <div class="payment-form-row md:!grid-cols-3">
              <div
                class="grid grid-cols-1 md:grid-cols-2 gap-x-6 col-span-full"
              >
                <div class="payment-form-row-item">
                  <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input
                      matInput
                      type="text"
                      placeholder="First Name"
                      formControlName="fname"
                    />
                    <mat-error>First name is required.</mat-error>
                  </mat-form-field>
                </div>

                <div class="payment-form-row-item">
                  <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input
                      matInput
                      type="text"
                      placeholder="Last Name"
                      formControlName="lname"
                    />
                    <mat-error>last name is required.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="payment-form-row-item">
                <mat-form-field>
                  <mat-label>Email Address</mat-label>
                  <input
                    matInput
                    type="email"
                    placeholder="Email Address"
                    formControlName="email"
                  />
                  <mat-error *ngIf="hasError('email', 'required')"
                    >Email required.</mat-error
                  >
                  <mat-error *ngIf="hasError('email', 'email')"
                    >Invalid email address.</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="payment-form-row-item">
                <mat-form-field>
                  <mat-label>Phone Number</mat-label>
                  <input
                    matInput
                    [textMask]="PHONE_NUMBER_INPUT_MASK_CONFIG"
                    type="text"
                    placeholder="Phone Number"
                    formControlName="phoneNumber"
                  />
                  <mat-error *ngIf="hasError('phoneNumber', 'required')"
                    >Phone number required.</mat-error
                  >
                  <mat-error *ngIf="hasError('phoneNumber', 'minLength')"
                    >Invalid phone number.</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="payment-form-row-item">
                <mat-form-field>
                  <mat-label>Date of Birth</mat-label>
                  <input
                    matInput
                    type="date"
                    placeholder="Date of Birth"
                    formControlName="dob"
                  />
                  <!-- <mat-error>Date of birth is required.</mat-error> -->
                </mat-form-field>
              </div>

              <div class="payment-form-row-item">
                <mat-form-field>
                  <mat-label>Street Address</mat-label>
                  <input
                    matInput
                    placeholder="Street Address"
                    formControlName="address"
                  />
                  <!-- <mat-error *ngIf="hasError('address', 'required')"
                    >Street Address required.</mat-error
                  > -->
                </mat-form-field>
              </div>

              <div class="payment-form-row-item">
                <mat-form-field>
                  <mat-label>Suite / Apartment</mat-label>
                  <input
                    matInput
                    placeholder="Suite / Apartment"
                    formControlName="apartment"
                  />
                  <!-- <mat-error *ngIf="hasError('apartment', 'required')"
                    >Street Address required.</mat-error
                  > -->
                </mat-form-field>
              </div>

              <div class="payment-form-row-item">
                <mat-form-field>
                  <mat-label>City</mat-label>
                  <input matInput placeholder="City" formControlName="city" />
                  <!-- <mat-error *ngIf="hasError('city', 'required')"
                    >City required.</mat-error
                  > -->
                </mat-form-field>
              </div>

              <div class="payment-form-row-item">
                <mat-form-field
                  class="dashboard-date-picker"
                  appearance="outline"
                >
                  <mat-label>State / Province</mat-label>
                  <input
                    [matAutocomplete]="auto"
                    formControlName="stateProvince"
                    name="state-province"
                    matInput
                    type="text"
                    placeholder="State / Province"
                  />
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option
                      *ngFor="let state of filteredOptions$ | async"
                      [value]="state.name"
                    >
                      {{ state.description }}
                    </mat-option>
                  </mat-autocomplete>
                  <!-- <mat-error *ngIf="hasError('stateProvince', 'required')"
                    >State / Province required.</mat-error
                  > -->
                </mat-form-field>
              </div>

              <div class="payment-form-row-item">
                <mat-form-field>
                  <mat-label>Zip / Postal Code</mat-label>
                  <input
                    matInput
                    placeholder="Zip / Postal Code"
                    formControlName="postalCode"
                  />
                  <!-- <mat-error *ngIf="hasError('postalCode', 'required')"
                    >Zip / Postal Code required.</mat-error
                  > -->
                </mat-form-field>
              </div>

              <div class="payment-form-row-item">
                <mat-form-field>
                  <mat-label>Country</mat-label>
                  <mat-select
                    formControlName="country"
                    name="country"
                    placeholder="Country"
                  >
                    <mat-option
                      *ngFor="let country of countries?.businessCodes"
                      [value]="country.name"
                      >{{ country.description }}</mat-option
                    >
                  </mat-select>
                  <!-- <mat-error *ngIf="hasError('country', 'required')"
                    >Country required.</mat-error
                  > -->
                </mat-form-field>
              </div>
            </div>

            <div
              [ngClass]="{
                'payment-form-row md:!grid-cols-3': true,
                '!hidden': !needCreditCard
              }"
            >
              <div
                [ngClass]="{
                  'payment-form-row-item': true
                }"
              >
                <div
                  [ngClass]="{
                    'payment-form-row-item': true
                  }"
                >
                  <mat-form-field class="w-full">
                    <mat-label>Card holder name</mat-label>
                    <input
                      matInput
                      type="text"
                      placeholder="John Doe"
                      class="rounded-md"
                      formControlName="cname"
                    />
                    <mat-error>Card holder name is required.</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                [ngClass]="{
                  'md:col-span-2 md:mb-[1.875rem] h-[60px] translate-y-1': true
                }"
              >
                <div
                  id="card-element"
                  [ngClass]="{
                    'w-full h-full transition flex flex-col items-stretch justify-center rounded border border-gray-300 px-4 ': true
                  }"
                ></div>
              </div>
            </div>
          </div>
          <div
            *ngIf="paymentError"
            class="flex p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
            role="alert"
          >
            <tix-icon
              svgIcon="exclamation-circle"
              class="inline w-5 h-5 mr-3"
            ></tix-icon>
            <div>
              <span class="font-bold block">Payment failed!</span>
              {{ paymentError }}
            </div>
          </div>
          <div class="tix-checkout-button-wrap">
            <div class="payment-form-row-item">
              <div class="tix-checkbox-line">
                <tix-checkbox
                  class="tix-agree-checkbox"
                  (change)="checkTerms($event)"
                  formControlName="terms"
                  [labelPosition]="'before'"
                >
                  I agree to the Purchasing
                  <a href="/policy-tos" target="_blank">
                    Terms and Conditions
                  </a>
                </tix-checkbox>
                <mat-error *ngIf="invalidTerms" class="error-msg"
                  >Terms is required.</mat-error
                >
              </div>
              <div class="tix-checkbox-line">
                <tix-checkbox
                  class="tix-agree-checkbox"
                  [labelPosition]="'before'"
                  formControlName="emails"
                >
                  I would like to receive future event information via email
                </tix-checkbox>
              </div>
              <div class="tix-checkbox-line">
                <tix-checkbox
                  class="tix-agree-checkbox"
                  [labelPosition]="'before'"
                  formControlName="sms"
                >
                  I would like to receive future event information via SMS
                </tix-checkbox>
              </div>
            </div>
            <div class="payment-form-row-item">
              <button
                type="submit"
                tix-button
                class="pay-now-button"
                [disabled]="
                  loading ||
                  (needCreditCard && !cardValid) ||
                  !canBuy ||
                  paymentForm.invalid
                "
                (click)="onSubmit(paymentForm.value)"
              >
                <ng-container *ngIf="!loading">
                  <tix-icon svgIcon="lock-outlined"></tix-icon>
                  {{ needCreditCard ? 'Pay Now' : 'Reserve Now' }}
                </ng-container>

                <ng-container *ngIf="loading">
                  <mat-spinner [diameter]="22"></mat-spinner>
                </ng-container>
              </button>
            </div>
            <div
              class="w-full px-5 py-4 rounded-md bg-primary bg-opacity-20"
              *ngIf="loading && showLatencyMessage"
            >
              This may take a while so bear with us :)
            </div>
          </div>
        </form>
      </div>
    </tix-card-content>
  </tix-card>
</div>
